import { render, staticRenderFns } from "./TutorialTooltip.vue?vue&type=template&id=4d9648c2&scoped=true&"
import script from "./TutorialTooltip.vue?vue&type=script&lang=js&"
export * from "./TutorialTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TutorialTooltip.vue?vue&type=style&index=0&id=4d9648c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9648c2",
  null
  
)

export default component.exports